import { EVENTS } from '../constants/webSocketConsts/events';
import { handleSignOut } from '../utils/UserUtils';
import { PortalConfig } from '../context';
import {
  handleDeletedClients,
  handleInsertedClients,
  handleModifiedClients,
} from '../store/clients/actions';

const ClientHandler = (
  event: string,
  items: Array<any>,
  portalConfig: PortalConfig,
  userID: string,
) => {
  switch (event) {
    case EVENTS.INSERT:
      return handleInsertedClients(items, true);
    case EVENTS.MODIFY:
      return handleModifiedClients(items, true);
    case EVENTS.REMOVE: {
      // eslint-disable-next-line react/destructuring-assignment
      const filteredItems = items.filter(item => item.id === userID);
      if (filteredItems && filteredItems.length > 0) {
        handleSignOut(
          portalConfig,
          Boolean(filteredItems[0].fields.isTestUser),
        );
      }
      return handleDeletedClients(items, true);
    }
    default:
      break;
  }
  return null;
};

export default ClientHandler;
